export default async ({ Vue }) => {
  Vue.config.ignoredElements = ['rc-live-preview-viewer', 'rc-streaming-video-player'];
};
